import script from "./devotion-page.vue?vue&type=script&setup=true&lang=js"
export * from "./devotion-page.vue?vue&type=script&setup=true&lang=js"

import "./devotion-page.vue?vue&type=style&index=0&id=5bfbd05c&lang=css"

const __exports__ = script;

export default __exports__